import styled from '@emotion/styled';
import { downloadBlob } from '@racemap/utilities/functions/download';
import { isArchivedTracker } from '@racemap/utilities/functions/validation';
import type { Immutable } from 'immer';
import { useIsAdmin, useTrackersForAction } from '../../../lib/customHooks';
import type { ManagedTracker } from '../../../store/trackers/trackers_reducers';

function buildTrackersCSVFile(trackers: Immutable<Array<ManagedTracker>>, isAdmin: boolean) {
  let csvString = 'id;tracker_id;tracker_name;device_type;iccid;tracker_link';
  for (const tracker of trackers) {
    if (tracker == null) {
      continue;
    }
    const trackerArchived = isArchivedTracker(tracker);

    if (trackerArchived && !isAdmin) {
      continue;
    }
    let row = [
      tracker.id,
      tracker.trackerId,
      tracker.trackerName,
      tracker.trackerType,
      tracker.meta?.iccid,
      `https://tr.racemap.com/${tracker.id}`,
    ];

    row = row.map((i) => (i == null ? '' : i));
    if (row.some((i) => i !== '')) {
      csvString += `\r\n${row.join(';')}`;
    }
  }
  return csvString;
}

export function CSVDownloadButton() {
  const trackersToUse = useTrackersForAction();
  const isAdmin = useIsAdmin();

  // revoke SOS from selected trackers
  const handleCSVDownload = async () => {
    if (trackersToUse == null) return;

    const now = new Date();
    const blob = new Blob([buildTrackersCSVFile(trackersToUse, isAdmin)], {
      type: 'text/csv;charset=utf-8;',
    });
    downloadBlob(blob, `TrackerList - ${now.toDateString()}.csv`);
  };

  return (
    <Container onClick={handleCSVDownload}>
      <div>Download as CSV</div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;
